export interface DemoIntegration {
  id: string;
  name: string;
  description: string;
  category: string;
  status: "connected" | "not_connected";
  isFeatured?: boolean;
  isPublic?: boolean;
  source?: "platform" | "custom";
  tools?: string[];
}

export const DEMO_INTEGRATIONS: DemoIntegration[] = [
  {
    id: "gmail",
    name: "Gmail",
    description: "Read, send, and manage your emails",
    category: "productivity",
    status: "connected",
    isFeatured: true,
    tools: [
      "List Emails",
      "Send Email",
      "Create Draft",
      "Search Emails",
      "Get Thread",
    ],
  },
  {
    id: "googlecalendar",
    name: "Google Calendar",
    description: "Manage events and view your schedule",
    category: "productivity",
    status: "connected",
    isFeatured: true,
    tools: [
      "List Events",
      "Create Event",
      "Update Event",
      "Delete Event",
      "List Calendars",
    ],
  },
  {
    id: "slack",
    name: "Slack",
    description: "Send messages and manage Slack channels",
    category: "communication",
    status: "connected",
    isFeatured: true,
    tools: ["Send Message", "List Channels", "List Messages", "Create Channel"],
  },
  {
    id: "github",
    name: "GitHub",
    description: "Manage repositories, issues, and pull requests",
    category: "developer",
    status: "connected",
    isFeatured: true,
    tools: ["List Repos", "List PRs", "Create Issue", "Get PR", "List Commits"],
  },
  {
    id: "notion",
    name: "Notion",
    description: "Access and manage Notion pages and databases",
    category: "productivity",
    status: "connected",
    isFeatured: true,
    tools: [
      "Get Page",
      "Create Page",
      "Search",
      "Update Page",
      "List Databases",
    ],
  },
  {
    id: "linear",
    name: "Linear",
    description: "Track issues, projects, and engineering workflows",
    category: "developer",
    status: "connected",
    isFeatured: true,
    isPublic: true,
    source: "custom",
    tools: ["List Issues", "Create Issue", "Update Issue", "List Projects"],
  },
  {
    id: "googledocs",
    name: "Google Docs",
    description: "Create and edit Google Docs documents",
    category: "productivity",
    status: "not_connected",
    tools: ["Create Document", "Get Document", "Update Document"],
  },
  {
    id: "googlesheets",
    name: "Google Sheets",
    description: "Read and write spreadsheet data",
    category: "productivity",
    status: "not_connected",
    tools: ["Read Sheet", "Write Sheet", "Append Row", "Create Spreadsheet"],
  },
  {
    id: "twitter",
    name: "Twitter",
    description: "Post tweets and manage your Twitter account",
    category: "social",
    status: "not_connected",
    tools: ["Post Tweet", "Get Timeline", "Search Tweets", "Get Analytics"],
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    description: "Share posts and manage your LinkedIn presence",
    category: "social",
    status: "not_connected",
    tools: ["Create Post", "Get Profile", "List Connections"],
  },
  {
    id: "todoist",
    name: "Todoist",
    description: "Manage tasks, projects, and to-do lists",
    category: "productivity",
    status: "not_connected",
    isPublic: true,
    source: "custom",
    tools: ["List Tasks", "Create Task", "Update Task", "List Projects"],
  },
  {
    id: "asana",
    name: "Asana",
    description: "Track projects, tasks, and team work",
    category: "productivity",
    status: "not_connected",
    isPublic: true,
    source: "custom",
    tools: ["List Tasks", "Create Task", "List Projects", "Get Project"],
  },
  {
    id: "trello",
    name: "Trello",
    description: "Manage boards, lists, and cards",
    category: "productivity",
    status: "not_connected",
    tools: ["List Boards", "Create Card", "Update Card", "List Cards"],
  },
  {
    id: "zoom",
    name: "Zoom",
    description: "Schedule and manage Zoom meetings",
    category: "communication",
    status: "not_connected",
    tools: ["Create Meeting", "List Meetings", "Get Meeting"],
  },
  {
    id: "googlemeet",
    name: "Google Meet",
    description: "Create and join Google Meet video calls",
    category: "communication",
    status: "not_connected",
    tools: ["Create Meeting", "Get Meeting"],
  },
  {
    id: "microsoft_teams",
    name: "Microsoft Teams",
    description: "Chat, call, and collaborate with your team",
    category: "communication",
    status: "not_connected",
    tools: ["Send Message", "List Channels", "Create Channel", "List Teams"],
  },
  {
    id: "clickup",
    name: "ClickUp",
    description: "Project management and team collaboration",
    category: "productivity",
    status: "not_connected",
    tools: ["List Tasks", "Create Task", "List Spaces"],
  },
  {
    id: "hubspot",
    name: "HubSpot",
    description: "CRM, marketing, and sales automation",
    category: "business",
    status: "not_connected",
    tools: ["List Contacts", "Create Contact", "List Deals", "Create Deal"],
  },
  {
    id: "airtable",
    name: "Airtable",
    description: "Flexible database and spreadsheet hybrid",
    category: "productivity",
    status: "not_connected",
    tools: ["List Records", "Create Record", "Update Record", "List Bases"],
  },
  {
    id: "reddit",
    name: "Reddit",
    description: "Browse subreddits and manage posts",
    category: "social",
    status: "not_connected",
    tools: ["List Posts", "Create Post", "Search"],
  },
  {
    id: "instagram",
    name: "Instagram",
    description: "Manage your Instagram content and analytics",
    category: "social",
    status: "not_connected",
    tools: ["Get Profile", "List Posts", "Get Insights"],
  },
  {
    id: "googletasks",
    name: "Google Tasks",
    description: "Manage your Google Tasks lists",
    category: "productivity",
    status: "not_connected",
    tools: ["List Tasks", "Create Task", "Update Task"],
  },
  {
    id: "google_maps",
    name: "Google Maps",
    description: "Search locations, get directions, and place info",
    category: "productivity",
    status: "not_connected",
    tools: ["Search Places", "Get Directions", "Get Place Details"],
  },
];

export const DEMO_CATEGORIES = [
  "all",
  "productivity",
  "communication",
  "developer",
  "social",
  "business",
];

export const CATEGORY_LABELS: Record<string, string> = {
  all: "All",
  productivity: "Productivity",
  communication: "Communication",
  developer: "Developer",
  social: "Social Media",
  business: "Business",
};
